import * as request from './request/request'
import * as utils from './utils'
import { encodeVisitorRecordParams, encodeVisitLogParams } from './common/visitorRecord'

export * from './enum/ActivityPageCfg'
export * from './enum/common'
export * from './enum/commonCountry'
export * from './enum/commonServiceType'
export * from './enum/env'
export * from './enum/ippCommon'
export * from './enum/oldAndNew'
export * from './enum/protocol'
export * from './enum/question'
export * from './enum/creditCard'
export * from './enum/gjtGlobalCountry'
export * from './enum/taxRate'
export * from './mixin'
export * from './enum/commonAreaCode'
export * from './enum/USAState'
export * from './enum/businessClue'
export * from './enum/invoice'
export * from './enum/buyGuide'
export * from './enum/bond'
export * from './enum/applicationManage'
export * from './enum/linkSafe'
export * from './enum/CertificationProductType'
export * from './enum/messagePolicyCfg'
export * from './enum/platformDataVerification'
export * from './enum/oudaiVerification'

import GenerateEnum from './generateEnum'
import { addNewColor } from '../dist/encryption/addNewColor.esm'

export { request, utils, GenerateEnum, addNewColor, encodeVisitorRecordParams, encodeVisitLogParams }



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/index.js